// extracted by mini-css-extract-plugin
module.exports = {"childList":"ChildList_childList__4x1vm","childList--spot":"ChildList_childList--spot__fRP5f","message":"ChildList_message__eECPP"};